<template>
  <b-container fluid style="margin-top:20px;">
    <b-button type="button" @click="refresh()" variant="primary" style="margin-bottom:19px;">refresh jobs</b-button>

    <b-table hover small responsive show-empty
      :fields="fields"
      :items="jobs"
      :busy="isLoading"
      empty-text="No files found.">
      <template v-slot:cell(actions)="row">
           <b-button size="sm" @click="showDetailsPage(row.item)" variant="primary"
            v-if="row.item.status === 'COMPLETED'" class="mr-1">
            view results
        </b-button>
      </template>

      <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
      </div>  
    </b-table>


  </b-container>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import {eventBus} from '@/main'

export default {

  components: {
  },

  data: () => ({
    isLoading: false, 
    jobs: [],
    selectedJob: {},
    fields: [
            {key: 'jobName', sortable: true, label: 'Job Name'},
            {key: 'status', sortable: true, label: 'Status'},
            {key: 'startDateTime', sortable: true, label: 'Started'},
            {key: 'completeDateTime', sortable: true, label: 'Completed'},
            {key: 'actions', label: 'Actions'}
        ],   
  }),

  props: {
    bucketName: {
      type: String,
      required: true,
    },
    bucketType: {
      type: String,
      required: true,
    },
    bucketId: {
      type: String,
      required: true,
    }
  },
  
  created () {  
    eventBus.$on('job-refresh', () => {
        this.initialize()
    })

    this.initialize()
  },
  
  methods: {
      initialize() {
        this.isLoading = true
        this.fetchTranscribeJobs()
      },

      refresh() {
        this.initialize();
      },

      fetchTranscribeJobs() {
          axios.get(config.CLOUDDRIVE_API_ENDPOINT + 'transcribe/jobs')
           .then((res) => {
                this.jobs = res.data
                this.isLoading = false
            })
            .catch((err) => {
                console.log(err)            
            })
        },

        download(file) {
        },

        editTags(file) {
          this.selectedJob = file
          this.$bvModal.show('modal-tags')
        },

        
        startTranscribeJob(file) {
          this.selectedJob = file
          this.$bvModal.show('prepare-job-modal')
        },

        closeTagModal() {
          this.$bvModal.hide('modal-tags')  
        },

        closeJobModal() {
          this.$bvModal.hide('prepare-job-modal')  
        },
        saveTags() {
          axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'updateTags', 
            this.selectedJob)
           .then((res) => {
            })
            .catch((err) => {
                console.log(err)            
            })
        },

        submitJob() {
           let payload = {
                bucketId: this.bucketId,
                bucketName: this.bucketName, 
                objectName: this.selectedJob.name
            }
            
            axios.post(config.CLOUDDRIVE_API_ENDPOINT + 'transcribe/voice', 
            payload)
           .then((res) => {
            })
            .catch((err) => {
                console.log(err)            
            })
        },

        showDetailsPage(item) {
          let routeData = this.$router.resolve({name: 'transcribeDetails', 
              params: {id: item.jobName}});
          window.open(routeData.href, '_blank');          
        },        
  }
}
</script>

<style lang="stylus">
primaryBlue = #3498db

form.dropzone
  transition all 0.2s linear
  border 2px dashed #ccc
  background-color #fafafa
  min-height initial
  &:hover
    border-color primaryBlue
    background-color white
    .dz-message
      .dropzone-title
        color primaryBlue
  .dz-message
    color #666
    span
      line-height 1.8
      font-size 13px
      letter-spacing 0.4px
      span.dropzone-title
        display block
        color #888
        font-size 1.25em
      span.dropzone-info
        display block
        color #a8a8a8
</style>